import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DisposableEmailCheckerContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Headline */}
      <Typography
        variant="h1"
        fontWeight="bold"
        sx={{ fontSize: "1.75rem" }}
        gutterBottom
      >
        Check for Disposable Emails Instantly{" "}
        <DeleteIcon color="primary" sx={{ verticalAlign: "middle" }} />
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Verify if an Email Address is Disposable or Temporary
      </Typography>

      {/* Problem & Solution */}
      <Typography variant="body1" paragraph>
        Disposable emails can ruin your marketing campaigns, fill your mailing
        list with junk, and skew your data. Manual checks aren’t reliable or
        scalable.
      </Typography>
      <Typography
        variant="body1"
        paragraph
        sx={{ fontWeight: "bold", color: "primary.main" }}
      >
        Our Disposable Email Checker instantly identifies if an email is
        disposable, using advanced validation and up-to-date blocklists.
      </Typography>

      {/* Benefits */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={3}>
        Why Use Our Disposable Email Checker?
      </Typography>
      <ul
        style={{
          textAlign: "left",
          display: "inline-block",
          listStyleType: "none",
          paddingLeft: 0,
        }}
      >
        <li>
          ✅ <strong>Instant Results:</strong> Know if an email is disposable in
          seconds
        </li>
        <li>
          🔍 <strong>Deep Checks:</strong> Updated disposable email domain
          databases
        </li>
        <li>
          🚫 <strong>Better Data:</strong> Keep your mailing list clean
        </li>
        <li>
          ⚡ <strong>One-Click:</strong> Just enter the email & check
        </li>
        <li>
          🔐 <strong>Private & Secure:</strong> We never store your data
        </li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How It Works
      </Typography>
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          p: 3,
          borderRadius: 2,
          textAlign: "left",
          display: "inline-block",
        }}
      >
        <ol>
          <li>
            <strong>Enter</strong> the email address you want to check
          </li>
          <li>
            <strong>Click</strong> the “Check Email” button
          </li>
          <li>
            <strong>We Verify</strong> the email against disposable email
            providers
          </li>
          <li>
            <strong>View</strong> the result instantly on screen
          </li>
        </ol>
      </Box>

      {/* Social Proof */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Trusted by Founders, Marketers & Developers
      </Typography>
      <Box sx={{ fontStyle: "italic", mb: 3 }}>
        <Typography paragraph>
          "This tool helps us weed out disposable emails before sending
          newsletters – a huge time saver!"
        </Typography>
        <Typography>- Priya K., Marketing Manager</Typography>
      </Box>

      {/* FAQ Section */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Frequently Asked Questions
      </Typography>

      <Box textAlign="left" sx={{ display: "inline-block" }}>
        <Typography variant="body1" fontWeight="bold">
          📧 How to check disposable email address?
        </Typography>
        <Typography variant="body2" paragraph sx={{ mb: 2 }}>
          Simply enter the email address and click “Check Email.” Our tool
          instantly identifies disposable email providers.
        </Typography>

        <Typography variant="body1" fontWeight="bold">
          🔍 How to check disposable email status?
        </Typography>
        <Typography variant="body2" paragraph sx={{ mb: 2 }}>
          We use a comprehensive database of disposable email domains to detect
          status in real-time.
        </Typography>

        <Typography variant="body1" fontWeight="bold">
          📨 How to check emails for disposable email address on Yahoo?
        </Typography>
        <Typography variant="body2" paragraph sx={{ mb: 2 }}>
          Enter any Yahoo email (or any other domain) into our tool – it’ll
          instantly show if it’s disposable.
        </Typography>

        <Typography variant="body1" fontWeight="bold">
          🧐 How to check if email is disposable?
        </Typography>
        <Typography variant="body2" paragraph>
          Use our tool to validate and detect disposable emails – simple and
          accurate.
        </Typography>
      </Box>

      {/* CTA */}
      <Box mt={4} mb={6}>
        <Typography variant="h6" paragraph sx={{ fontWeight: "bold" }}>
          Ready to check disposable emails?
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={scrollToTop}
          sx={{
            fontSize: "1.1rem",
            py: 1.5,
            px: 4,
            fontWeight: "bold",
          }}
        >
          Check Email →
        </Button>
        <Typography variant="caption" display="block" mt={1}>
          1 credit per check for Free user. This is complimentary tool Paid user so 0 credits.
        </Typography>
      </Box>
    </Container>
  );
};

export default DisposableEmailCheckerContent;
